import React, { useEffect, useContext, useState, useRef } from 'react'

import { useNavigate } from 'react-router-dom';

import {
  Box,
} from '@mui/material';

import APIS from "../../../../utils/APIS"

import {getPointsByQuizz} from "../../../../contexts/UserContext"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"

import { adminInputStyle } from "../adminStyles.js"

const ContentForm = ({ content, setHasChanged }) => {
  const navigate = useNavigate()

  const { setGroupes, updateAdminContents, setOverlayForSave } = useContext(SuperAdminContext)

  const [actFormation, setActFormation] = useState(undefined)

  const [name, setName] = useState("")
  const [surname, setSurname] = useState("")
  const [description, setDescription] = useState("")
  const [timing, setTiming] = useState("")
  const [type, setType] = useState("")
  const [theme, setTheme] = useState(null)
  const [niveau, setNiveau] = useState(null)
  const [cible, setCible] = useState(null)
  const [langue, setLangue] = useState(null)
  const [categories, setCategories] = useState([])
  const [softSkills, setSoftSkills] = useState([])

  const [categoriesForGlbMaster, setCategoriesForGlbMaster] = useState([])
  const [glbMasterPond, setGlbMasterPond] = useState([])
  const [glbMasterMaxPoints, setGlbMasterMaxPoints] = useState(0)

  useEffect(() => {
    let maxPoints = 0
    Object.keys(categoriesForGlbMaster).map((keyName, i) => {
      let statut = "non" // 07/10/2026 : selection manuelle, jamais par defaut (comme le calcul, utils/scoreGlobal.js)
      let find = glbMasterPond.find((el) => el.key === keyName)
      if (find) {
        statut = find.value
      }
      if (statut === "oui") {
        maxPoints += categoriesForGlbMaster[keyName].max
      }
      setGlbMasterMaxPoints(maxPoints)
    })
  }, [categoriesForGlbMaster, glbMasterPond])

  const getCategories = (formation, withMaster) => {
    let categories = []
    const manageFormat = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        const [points, max] = getPointsByQuizz(format)
        const makeResult = (c, points, max, format) => {
          let newPoints = c.points+points
          let newMax = c.max+max
          return {
            quizz : ['Quizz'].includes(format.type) ? c.quizz + 1 : c.quizz,
            questionnaireV2 : ['QuestionnaireV2'].includes(format.type) ? c.questionnaireV2 + 1 : c.questionnaireV2,
            points : newPoints,
            max : newMax,
            score : Math.round((newPoints / newMax) * 100)
          }
        }
        if (withMaster === true) {
          if (format.categorie && format.categorie !== 'glbMaster') {
            categories[format.categorie] = makeResult(categories[format.categorie] ?? { points: 0, max: 0, score: 0, quizz: 0, questionnaireV2:0  }, points, max, format)
          }
        } else {
          if (format.categorie && format.categorie !== 'master' && format.categorie !== 'glbMaster') {
            categories[format.categorie] = makeResult(categories[format.categorie] ?? { points: 0, max: 0, score: 0, quizz: 0, questionnaireV2:0  }, points, max, format)
          }
        }
      }
    }

    for (var iChap in formation.chapitre) {
      for (var iPart in formation.chapitre[iChap].partie) {
        for (var n in formation.chapitre[iChap].partie[iPart].sequence) {
          var format = formation.chapitre[iChap].partie[iPart].sequence[n]
          manageFormat(format)
        }
      }
    }

    return categories
  }


  const initFct = async () => {
    if (content) {
      let find = await APIS.getContentByIdForAdmin({id : content?.id})

      setName(find.name || "")
      setSurname(find.surname || "")
      setDescription(find.description || "")
      setTiming(find.timing || 0)
      setType(find.type)
      setTheme(find.theme)
      setNiveau(find.niveau)
      setCible(find.cible)
      setLangue(find.langue)
      let newCategories = getCategories(find, false)
      setCategories(newCategories)
      if (find.softSkills === null) {
        setSoftSkills([])
      } else {
        //on vérifie qu'il n'y ai pas des softskills présent dans cet array mais sans catégories
        let newSoftSkills = JSON.parse(find.softSkills)
        let categoriesKeys = Object.keys(newCategories)
        newSoftSkills = newSoftSkills.filter((skill) => {
          let find = categoriesKeys.find((el) => el === skill.key)
          if (find) {
            return true
          }
        })
        if (newSoftSkills?.length !== JSON.parse(find.softSkills)?.length) {
          alert("Les softskills ont été modifiés automatiquement. Merci d'enregistrer ces modifications\u00a0!")
        }
        setSoftSkills(newSoftSkills)
      }
      if (find.glbMasterPond === null) {
        setGlbMasterPond([])
      } else {
        setGlbMasterPond(JSON.parse(find.glbMasterPond))
      }
      setActFormation(find)

      setCategoriesForGlbMaster(getCategories(find, true))
    }
  }

  useEffect(() => {
    initFct()
  }, [content])

  const handleSoftSkillsChange = (key, value) => {
    let find = softSkills.find((el) => el.key === key)
    if (find) {
      let family = find.family || "efficacite"
      const newSoftSkills = softSkills.map(s => {
        if (s.key === key) {
          return {
            key : s.key,
            value : value,
            family : family,
            display : s.display
          }
        } else {
          return s
        }
      });
      setSoftSkills(newSoftSkills)
    } else {
      let family = "efficacite"
      setSoftSkills([
        ...softSkills,
        { key: key, value: value, family : family, }
      ])
    }
  }

  const handleCategoriesDisplay = (key, value) => {
    let find = softSkills.find((el) => el.key === key)
    if (find) {
      let family = find.family || "efficacite"
      const newSoftSkills = softSkills.map(s => {
        if (s.key === key) {
          return {
            key : s.key,
            value : s.value,
            family : family,
            display : value
          }
        } else {
          return s
        }
      });
      setSoftSkills(newSoftSkills)
    } else {
      let family = "efficacite"
      setSoftSkills([
        ...softSkills,
        { key: key, value: "nc", family : family, display : value }
      ])
    }
  }

  const handleSoftSkillsFamilyChange = (key, value) => {
    let find = softSkills.find((el) => el.key === key)
    if (find) {
      const newSoftSkills = softSkills.map(s => {
        if (s.key === key) {
          return {
            key : s.key,
            value : s.value,
            display : s.display,
            family : value,
          }
        } else {
          return s
        }
      });
      setSoftSkills(newSoftSkills)
    }
  }

  const handleGlbMasterPondChange = (key, value) => {
    let find = glbMasterPond.find((el) => el.key === key)
    if (find) {
      const newGlbMasterPond = glbMasterPond.map(s => {
        if (s.key === key) {
          return {
            key : s.key,
            value : value,
          }
        } else {
          return s
        }
      });
      setGlbMasterPond(newGlbMasterPond)
    } else {
      setGlbMasterPond([
        ...glbMasterPond,
        { key: key, value: value }
      ])
    }
  }

  useEffect(() => {
    if (actFormation) {
      let defaultSoftSkills = JSON.parse(actFormation.softSkills)
      if (defaultSoftSkills === null) { defaultSoftSkills = [] }
      let defaultGlbMasterPond = JSON.parse(actFormation.glbMasterPond)
      if (defaultGlbMasterPond === null) { defaultGlbMasterPond = [] }
      if (
        name !== actFormation.name
        || surname !== actFormation.surname
        || description !== actFormation.description
        || type !== actFormation.type
        || theme !== actFormation.theme
        || niveau !== actFormation.niveau
        || cible !== actFormation.cible
        || langue !== actFormation.langue
        || parseInt(timing) !== parseInt(actFormation.timing)
        || JSON.stringify(softSkills) !== JSON.stringify(defaultSoftSkills)
        || JSON.stringify(glbMasterPond) !== JSON.stringify(defaultGlbMasterPond)
      ) {
        setHasChanged(true)
      } else {
        setHasChanged(false)
      }
    }
  }, [name, surname, description, timing, type, theme, niveau, cible, langue, softSkills, glbMasterPond, actFormation])

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setHasChanged(false)
    if (name !== "" && surname !== "" && description !== "" && type !== "" && softSkills !== "" && glbMasterPond !== "" && isNaN(parseInt(timing)) !== true) {
      let defaultSoftSkills = JSON.parse(actFormation.softSkills)
      if (defaultSoftSkills === null) { defaultSoftSkills = [] }
      let values = {
        id : actFormation.id,
        name : name,
        surname : surname,
        description : description,
        timing : parseInt(timing),
        type : type,
        theme : theme,
        niveau : niveau,
        cible : cible,
        langue : langue,
        softSkills : JSON.stringify(softSkills),
        glbMasterPond : JSON.stringify(glbMasterPond),
      }
      if(JSON.stringify(softSkills) !== JSON.stringify(defaultSoftSkills)) {
        values.softSkillsChanged = true;
      }
      setOverlayForSave(true)
      APIS.editContent(values).then((result) => {
        if (result) {
          //on s'occupe des groupes
          if (result?.reloadGroupes === true && result?.groupes) {
            setGroupes(result?.groupes)
          }
          if (actFormation.archived === "true") {
            updateAdminContents(true)
          } else {
            updateAdminContents(false)
          }
          initFct()
          setOverlayForSave(false)
        } else {
          alert("Erreur\u00a0!")
          setHasChanged(true)
          setOverlayForSave(false)
        }
      })
    } else {
      alert ("Il y a un problème avec les informations renseignées")
      setHasChanged(true)
    }
  }

  return (
    <>
      {actFormation &&
        <form noValidate onSubmit={onSubmitForm}>
          <Box sx={{ padding:"0px 10px",}}>
            <Box>
              <Box>Nom du module</Box>
              <input
                onChange={(e) => {setName(e.target.value)}}
                value={name}
                id="name"
                name="name"
                placeholder="FOCUS-SoftSkill"
                type="text"
                style={adminInputStyle}
              />
            </Box>

            <Box>
              <Box>Surnom du module</Box>
              <input
                onChange={(e) => {setSurname(e.target.value)}}
                value={surname}
                id="surname"
                name="surname"
                placeholder=""
                type="text"
                style={adminInputStyle}
              />
            </Box>

            {/* ⛔ POINT 70 DE LA FICHE V2, « le champ bloque au-dela d'une
                certaine longueur ». C'etait un `maxLength` de 255 sur une
                ligne unique : la frappe s'arretait, sans un mot.
                ⚠️ VERIFIE EN PRODUCTION le 07/09 : la colonne
                `contents.description` y est un LONGTEXT, pas un varchar(255).
                La base n'a jamais limite quoi que ce soit, c'est bien ce
                `maxLength` qui bloquait, et lui seul. Il est retire.
                (Ma base locale, elle, avait un varchar(255) : deux schemas
                divergents. Ne pas conclure de l'un sur l'autre.)
                Le champ reste une zone de texte, avec un compteur qui informe
                sans contraindre. */}
            <Box>
              <Box sx={{display:"flex", alignItems:"baseline", justifyContent:"space-between", gap:"10px"}}>
                <Box>Description du module</Box>
                <Box sx={{fontSize:"11px", color:"#7C7C7C"}}>
                  {(description || "").length} caractères
                </Box>
              </Box>
              <textarea
                onChange={(e) => {setDescription(e.target.value)}}
                value={description}
                id="description"
                name="description"
                rows={3}
                style={{...adminInputStyle, height:"auto", resize:"vertical", fontFamily:"inherit"}}
              />
            </Box>

            <Box>
              <Box>Durée du module (en minutes)</Box>
              <input
                onChange={(e) => {setTiming(e.target.value)}}
                value={timing}
                id="timing"
                name="timing"
                placeholder=""
                type="text"
                style={adminInputStyle}
              />
            </Box>

            <Box>
              <Box>Type</Box>
              <select
                onChange={(e) => {
                  let newType = e.target.value
                  if (type === "icebreaker" || newType === "icebreaker") {
                    APIS.checkForChangeContentType({id : actFormation.id, oldType : type}).then((result) => {
                      if (result?.message === "checkForChangeContentType") {
                        if (result?.nbr === 0) {
                          setType(newType)
                        } else {
                          if (type === "icebreaker") { //type actuel en icebreaker
                            let text = "Erreur\u00a0! Cette formation est utilisée en icebreaker dans le(s) groupe(s) suivant(s)\u00a0:";
                            result?.groupes.forEach(groupe => {
                              text+="\n - "+groupe
                            })
                            alert(text)
                          } else { //type actuel pas en icebreaker
                            let text = "Erreur\u00a0! Cette formation est utilisée dans le(s) groupe(s) suivant(s)\u00a0:";
                            result?.groupes.forEach(groupe => {
                              text+="\n - "+groupe
                            })
                            alert(text)
                          }
                        }
                      } else {
                        alert("Une erreur est survenue")
                      }
                    })
                  } else {
                    setType(newType)
                  }
                }}
                id="type"
                name="type"
                style={{width:'150px', marginTop:'3px',}}
                value={type}
                disabled={actFormation?.id === 60 ? true : false}
              >
                <option value="identif">
                  Identifier
                </option>
                <option value="enrich">
                  Enrichir
                </option>
                <option value="icebreaker">
                  Icebreaker
                </option>
              </select>
            </Box>

            <Box sx={{marginTop:'10px'}}>
              <Box>Theme</Box>
              <select
                onChange={(e) => {setTheme(e.target.value)}}
                id="theme"
                name="theme"
                style={{width:'200px', marginTop:'3px',}}
                value={theme}
              >
                <option value="">
                  Non défini
                </option>
                <option value="efficacite">
                  Efficacité opérationnelle
                </option>
                <option value="communication">
                  Communication et innovation
                </option>
                <option value="leadership">
                  Leadership et collaboration
                </option>
                <option value="demo">
                  Demo
                </option>
              </select>
            </Box>

            <Box sx={{marginTop:'10px'}}>
              <Box>Niveau</Box>
              <select
                onChange={(e) => {setNiveau(e.target.value)}}
                id="niveau"
                name="niveau"
                style={{width:'100px', marginTop:'3px',}}
                value={niveau}
              >
                <option value="">
                  Non défini
                </option>
                <option value="1">
                  1
                </option>
                <option value="2">
                  2
                </option>
                <option value="3">
                  3
                </option>
              </select>
            </Box>

            <Box sx={{marginTop:'10px'}}>
              <Box>Cible</Box>
              <select
                onChange={(e) => {setCible(e.target.value)}}
                id="cible"
                name="cible"
                style={{width:'100px', marginTop:'3px',}}
                value={cible}
              >
                <option value="">
                  Non défini
                </option>
                <option value="school">
                  École
                </option>
                <option value="corpo">
                  Corporate
                </option>
              </select>
            </Box>

            <Box sx={{marginTop:'10px'}}>
              <Box>Langue</Box>
              <select
                onChange={(e) => {setLangue(e.target.value)}}
                id="langue"
                name="langue"
                style={{width:'100px', marginTop:'3px',}}
                value={langue}
              >
                <option value="">
                  Non défini
                </option>
                <option value="fr">
                  Français
                </option>
                <option value="en">
                  Anglais
                </option>
              </select>
            </Box>

            <Box sx={{marginTop:'15px'}}>
              <Box sx={{marginBottom:"4px"}}>glbMaster pondération ({glbMasterMaxPoints} points)</Box>
              {Object.keys(categoriesForGlbMaster).map((keyName, i) => {
                let statut = "non" // 07/10/2026 : selection manuelle, jamais par defaut (comme le calcul, utils/scoreGlobal.js)
                let find = glbMasterPond.find((el) => el.key === keyName)
                if (find) {
                  statut = find.value
                }
                return (
                  <Box key={"catList"+i} sx={{display:"flex", alignItems:"center", marginBottom:'5px', marginLeft:'5px'}}>
                    <Box sx={{fontSize:'14px'}}>
                      - {keyName} ({categoriesForGlbMaster[keyName].max} points)&nbsp;: &nbsp;
                    </Box>
                    <select
                      onChange={(e) => { handleGlbMasterPondChange(keyName, e.target.value) }}
                      id="catGlbMaster"
                      name="catGlbMaster"
                      style={{width:'150px'}}
                      value={statut}
                    >
                      <option value="oui">
                        Prendre en compte
                      </option>
                      <option value="non">
                        Ignorer
                      </option>
                    </select>
                  </Box>
                )
              })}
            </Box>

            <Box sx={{marginTop:'15px'}}>
              <Box sx={{marginBottom:"4px"}}>Catégories&nbsp;: Masquer / SoftSkills</Box>
              {(categories && Object.keys(categories).length === 0) &&
                <p style={{marginBottom:'5px', marginLeft:'5px'}}>
                  Aucune catégorie dans cette formation
                </p>
              }
              {Object.keys(categories).map((keyName, i) => {
                //console.log(softSkills)
                let statut = "nc"
                let display = "oui"
                let find = softSkills.find((el) => el.key === keyName)
                if (find) {
                  if (find.display) {
                    display = find.display
                  }
                  if (find.value) {
                    statut = find.value
                  }
                }
                return (
                  <Box key={"catList"+i} sx={{display:"flex", alignItems:"center", marginBottom:'5px', marginLeft:'5px'}}>
                    <Box sx={{fontSize:'14px'}}>
                      - {keyName}&nbsp;: &nbsp;
                    </Box>
                    <select
                      onChange={(e) => { handleCategoriesDisplay(keyName, e.target.value) }}
                      id="categoriesDisplay"
                      name="categoriesDisplay"
                      style={{width:'100px'}}
                      value={display}
                    >
                      <option value="oui">
                        Afficher
                      </option>
                      <option value="non">
                        Masquer
                      </option>
                    </select>
                    <select
                      onChange={(e) => { handleSoftSkillsChange(keyName, e.target.value) }}
                      id="softSkillsType"
                      name="softSkillsType"
                      style={{width:'150px', marginLeft:"30px"}}
                      value={statut}
                    >
                      <option value="nc">
                        Non défini
                      </option>
                      <option value="oui">
                        Oui
                      </option>
                      <option value="non">
                        Non
                      </option>
                    </select>
                    {statut === "oui" &&
                      <select
                        onChange={(e) => { handleSoftSkillsFamilyChange(keyName, e.target.value) }}
                        id="type"
                        name="type"
                        style={{width:'200px', marginLeft:"15px"}}
                        value={find.family || "efficacite"}
                      >
                        <option value="efficacite">
                          Efficacité opérationnelle
                        </option>
                        <option value="communication">
                          Communication et innovation
                        </option>
                        <option value="leadership">
                          Leadership et collaboration
                        </option>
                      </select>
                    }
                  </Box>
                )
              })}
            </Box>
          </Box>

          <button hidden type="submit" id="hidden_form_submit">
            Éditer
          </button>

        </form>
      }
    </>
  )
};

export default ContentForm;
